/**
 * Slider
 */
import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Autoplay,
} from 'swiper/modules';

class ModuleSwiper {
    defaults = {
        selectors: {
            'slider': '.swiper',
        },
        options: {
            slideAuto: {
                modules: [Autoplay, Navigation, Pagination],
                spaceBetween: 0,
                speed: 900,
                slidesPerView: "auto",
                autoHeight: true,
                observer: false,
                observeParents: false,
                parallax:true,
                grabCursor: true,
                disableOnInteraction: false,


                autoplay: {
                    delay: 3200,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    dynamicBullets: true,
                    clickable: true,
                },

                on: {
                    init: function (swiper) {
                        if (this.isLocked) {
                            this.el.classList.add("swiper-locked")
                        }

                        let section = swiper.el.closest('section');
                        let thumbsText = section.querySelectorAll('[data-slide-item]');
                        if (swiper.slides.length == thumbsText.length){
                            thumbsText.forEach((text => {
                                let idxItem = parseInt(text.getAttribute('data-slide-item'));
                                if (!idxItem) {
                                    text.style.display = "none";
                                    return false;
                                }
                                if (idxItem === swiper.activeIndex + 1) {
                                    text.style.display = "";
                                } else {
                                    text.style.display = "none";
                                }
                            }))
                        }

                        let thumbsTab = section.querySelectorAll('[data-slide-tab]');
                        if (swiper.slides.length == thumbsTab.length){
                            thumbsTab.forEach((tab => {
                                let idxItem = parseInt(tab.getAttribute('data-slide-tab'));                                
                                if (!idxItem) {
                                    tab.classList.remove('active');
                                    return false;
                                }
                                if (idxItem === swiper.activeIndex + 1) {
                                    tab.classList.add('active');
                                } else {
                                    tab.classList.remove('active');
                                }
                            }))
                        }
                    },
                    slideChange: function (swiper) {
                        if (this.isLocked) {
                            this.el.classList.add("swiper-locked")
                        }

                        let section = swiper.el.closest('section');
                        let thumbsText = section.querySelectorAll('[data-slide-item]');

                        if (swiper.slides.length == thumbsText.length){
                            thumbsText.forEach((text => {
                                let idxItem = parseInt(text.getAttribute('data-slide-item'));
                                if (!idxItem) {
                                    text.style.display = "none";
                                    return false;
                                }
                                if (idxItem === swiper.activeIndex + 1) {
                                    text.style.display = "";
                                } else {
                                    text.style.display = "none";
                                }
                            }))
                        }

                        let thumbsTab = section.querySelectorAll('[data-slide-tab]');
                        if (swiper.slides.length == thumbsTab.length){
                            thumbsTab.forEach((tab => {
                                let idxItem = parseInt(tab.getAttribute('data-slide-tab'));                                
                                if (!idxItem) {
                                    tab.classList.remove('active');
                                    return false;
                                }
                                if (idxItem === swiper.activeIndex + 1) {
                                    tab.classList.add('active');
                                } else {
                                    tab.classList.remove('active');
                                }
                            }))
                        }
                    },
                },
            },
            slideAutoCol: {
                modules: [Autoplay, Navigation, Pagination],
                direction: "vertical",
                spaceBetween: 0,
                speed: 900,
                slidesPerView: "auto",
                autoHeight: true,

                autoplay: {
                    delay: 3200,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    dynamicBullets: true,
                    clickable: true,
                },

                on: {
                    init: function (swiper) {
                        if (this.isLocked) {
                            this.el.classList.add("swiper-locked")
                        }

                        let section = swiper.el.closest('section');
                        let thumbsText = section.querySelectorAll('[data-slide-item]');

                        if (swiper.slides.length == thumbsText.length){
                            thumbsText.forEach((text => {
                                let idxItem = parseInt(text.getAttribute('data-slide-item'));
                                if (!idxItem) {
                                    text.style.display = "none";
                                    return false;
                                }
                                if (idxItem === swiper.activeIndex + 1) {
                                    text.style.display = "";
                                } else {
                                    text.style.display = "none";
                                }
                            }))
                        }
                    },
                    slideChange: function (swiper) {
                        if (this.isLocked) {
                            this.el.classList.add("swiper-locked")
                        }

                        let section = swiper.el.closest('section');
                        let thumbsText = section.querySelectorAll('[data-slide-item]');

                        if (swiper.slides.length == thumbsText.length){
                            thumbsText.forEach((text => {
                                let idxItem = parseInt(text.getAttribute('data-slide-item'));
                                if (!idxItem) {
                                    text.style.display = "none";
                                    return false;
                                }
                                if (idxItem === swiper.activeIndex + 1) {
                                    text.style.display = "";
                                } else {
                                    text.style.display = "none";
                                }
                            }))
                        }
                    },
                },
            },
        }
    }

    constructor() {
        this.slider();
    }

    handleDevices(sw, { itemSlider, option }, minWidth = 768, maxWidth = null) {
        sw.destroy();

        const handleSlide = () => {
            if (window.innerWidth >= minWidth && (!maxWidth || window.innerWidth < maxWidth)) {
                if (sw.destroyed == true) {
                    sw = new Swiper(itemSlider, option);
                }
            } else {
                if (!sw.destroyed && sw.initialized) {
                    sw.destroy();
                }
                itemSlider.style.display = "flex";
            }
        }

        handleSlide();
        window.addEventListener('resize', handleSlide);
    }

    slider() {
        const { selectors, options } = this.defaults;
        const slideItem = this.slideItem;
        const handleDevices = this.handleDevices;
        const slideSelectors = document.querySelectorAll(selectors.slider);
        slideSelectors.forEach(function (itemSlider) {
            slideItem(itemSlider, options, function(sw, option){
                handleDevices(sw, { itemSlider, option }, 0, 1024)
            })
        });
    }

    slideItem(itemSlider, options, callback) {
        if (itemSlider.classList.contains('swiper-initialized')) {
            return false;
        }
        let option = { ...options[itemSlider.dataset.slide] ?? {} };
        const parrent = itemSlider.closest('.tab-section') || itemSlider.closest('section');

        if (option.navigation) {
            option.navigation.prevEl = parrent.querySelector('.swiper-button-prev');
            option.navigation.nextEl = parrent.querySelector('.swiper-button-next');

            if (!option.navigation.prevEl || !option.navigation.nextEl) {
                option.navigation = false;
            }
        } else {
            option.navigation = false;
        }

        if (option.pagination) {
            option.pagination.el = parrent.querySelector('.swiper-pagination');

            if (!option.pagination.el) {
                option.pagination = false;
            }
        } else {
            option.pagination = false;
        }

        let loop = itemSlider.dataset.loop;
        if (loop !== undefined) {
            if (loop === "true") {
                option.loop = true;
            } else {
                option.loop = false;
            }
        }


        let speed = itemSlider.dataset.speed;
        if (speed !== undefined) {
            if (parseInt(speed)) {
                option.autoplay.speed = speed;
            } else {
                option.autoplay.speed = "700";
            }
        }

        let autoHeight = itemSlider.dataset.autoheight;
        if (autoHeight !== undefined) {
            if (autoHeight === "false") {
                option.autoHeight = false;
            } else {
                option.autoHeight = true;
            }
        }
        itemSlider.style.display = "";

        if (itemSlider.dataset.slide == 'slideTools') {
            return;
        }

        let autoplay = itemSlider.dataset.autoslide;
        if (autoplay !== undefined && autoplay === "false"){
            option.modules = option.modules.filter(function(moduleItem) {
                return moduleItem.name !== "Autoplay";
            });
            option.autoplay = false;
        }

        let sw = new Swiper(itemSlider, option);
        sw.disable();
        
        if (itemSlider.dataset.display == "mobile") {
            callback(sw, option)
        }

        if (itemSlider.dataset.thumb){
            let gallery = document.querySelector(`[data-gallery="${itemSlider.dataset.thumb}"]`);
            let slidesGallery = gallery?.querySelectorAll('.swiper-slide');

            slidesGallery?.forEach((item, idx) => {
                if (idx === 0){
                    item.classList.add('thumb-slide-active');
                }
                item.addEventListener('click', (e) => {
                    e.preventDefault();

                    slidesGallery.forEach(temp => temp.classList.remove('thumb-slide-active'));
                    item.classList.add('thumb-slide-active');
                    sw.enable();
                    sw.slideTo(idx);
                })
            })

            sw.on('slideChange', function(swiper){
                let iActive = swiper.activeIndex;
                slidesGallery.forEach(temp => temp.classList.remove('thumb-slide-active'));
                slidesGallery[iActive].classList.add('thumb-slide-active');
            })
        }

        let thumbsTab = parrent.querySelectorAll('[data-slide-tab]');
        thumbsTab.forEach((tab => {
            let idxItem = parseInt(tab.getAttribute('data-slide-tab'));
            if (idxItem){
                tab.addEventListener('click', (e) => {
                    e.preventDefault();
                    sw.enable();
                    sw.slideTo(parseInt(idxItem) - 1);
                })
            }
        }))

        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        let autoplay = itemSlider.dataset.autoslide;
                        if (autoplay !== undefined) {
                            if (autoplay === "false") {
                                sw.autoplay && sw.autoplay.pause();
                            } else {
                                sw.autoplay && sw.autoplay.start();
                            }
                        } else {
                            sw.autoplay && sw.autoplay.start();
                        }
                        sw.enable();
                        sw.update();
                    }
                    else {
                        sw.autoplay && sw.autoplay.pause();
                        sw.disable();
                    }
                });
            },
            { threshold: 0.33 }
        );
        observer.observe(itemSlider);
        return sw;
    }

    getDefaults() {
        return this.defaults;
    }
}

export default ModuleSwiper;